import styled from 'styled-components';

export const UserImage = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 50%;
`;
